import { render } from "./AddBankDetail.vue?vue&type=template&id=67b3003e"
import script from "./AddBankDetail.vue?vue&type=script&lang=js"
export * from "./AddBankDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__